import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { SearchResults } from '../../common/types/api/v4/boats/search';
import { SeoData } from '../../common/types/api/v4/rutter/v1/search/seo';
import SearchStore from './SearchStore';

let store: null | SearchStore = null;

/**
 * Provides access to the store.
 */
const useSearchStore = (
  initialSearchResults: SearchResults,
  initialSeo: SeoData,
  currency: string,
  isNearbySearch: boolean,
): SearchStore => {
  const router = useRouter();

  if (!store || typeof window === 'undefined') {
    store = new SearchStore({
      initialSearchResults, initialSeo, router, currency, isNearbySearch,
    });
  }

  // Update the search results and seo content when the page props change
  useEffect(() => {
    if (store) {
      store.setSearchResults(initialSearchResults);
      store.setSeo(initialSeo);
    }
  }, [
    initialSearchResults,
    initialSeo,
  ]);

  // Ensure the router reference is always up to date.
  useEffect(() => {
    if (store) {
      store.setRouter(router);
    }
  }, [router]);

  // Notify the store when the route changes.
  useEffect(() => {
    if (store) {
      store.onRouteChange(router.asPath, router.query);
    }
  }, [router.asPath, router.query]);

  // Notify the store when the currency changes.
  useEffect(() => {
    if (store && store.currency.value !== currency) {
      store.onCurrencyChange(currency);
    }
  }, [currency]);

  // Conditionally expose the store for debugging purposes by appending `&expose=searchStore`
  if (typeof window !== 'undefined' && router.query.expose === 'searchStore') {
    // @ts-expect-error - searchStore is not a known global
    window.searchStore = store;
  }
  return store;
};

export default useSearchStore;
